import type { ComponentProps } from "react"
import { forwardRef } from "react"

import { cn } from "@productlane/lib/src/browser"

import { IssuesAmountIcon } from "../../icons"
import { Badge } from "../badge"
import { Tooltip } from "../tooltip"

interface IssuesAmountIndicatorProps extends ComponentProps<"div"> {
	amount: number | null
}

export const IssuesAmountIndicator = forwardRef<
	HTMLDivElement,
	IssuesAmountIndicatorProps
>(({ amount, className }, _ref) => {
	if (amount === null || amount <= 0) {
		return null
	}

	return (
		<Tooltip
			label={`Issues in this project: ${amount}`}
			side="bottom"
			enabled={true}
		>
			<Badge
				variant="default"
				size="default"
				className={cn("mr-6 rounded-full px-2", className)}
			>
				<IssuesAmountIcon className="h-3 w-3 text-tertiary" />
				<span className="whitespace-nowrap">{amount} issues</span>
			</Badge>
		</Tooltip>
	)
})
